angular.module 'app'
.controller 'WechatLogCtrl', ($scope, $state, $stateParams, $http, Storage, $rootScope, growl, config, dialogs) ->
  return $state.go 'app.wechat' if Storage.get('user_permission').system.log.is_use == false

  $scope.ui =
    isLoading: false
    currentPage: 1
    perPage: 10
    maxSize: 8
    totalItems: 0
    user: ""
    groupId: ''
    logs: []
    operations: []
    wechats: []
    eadminDisplay: config.eadmin.display

    date:
      startDate: moment().subtract(1, 'days')
      endDate: moment()
    opts: config.opts

  # 設置日曆
  $scope.ui.opts.parentEl = 'div#material-graphic'
  $scope.ui.opts.opens = 'right'

  do fetchWechat = ->
    $http.get "#{config.api.baseUrl}/manage/log_usages/wechats?access_token=" + Storage.get('access_token'), {}
    .then (res) ->
      $scope.ui.wechats  = res.data
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  do fetchType = ->
    $http.get "#{config.api.baseUrl}/manage/log_usages/operations?access_token=" + Storage.get('access_token'),
      {}
    .then (res) ->
      $scope.ui.operations  = res.data
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  fetchUsers = ->
    if $scope.ui.eadminDisplay == true
      users = """
        query(
          $query: UserQueryInput
        ){
          user(
            query: $query
          ){
            count
            data{
              id
              username
              email
              lang
              createdAt
              roles(
                query: {}
              ){
                roleId
                groupId
                productId
                roleName
                groupName
                productName
                createdAt
              }
            }
          }
        }
      """
      variables =
        query:
          groupId: $scope.ui.groupId
          productId: String(config.eadmin.clientId)
          limit: 1000
      $http.post "#{config.eadmin.newBaseUrl}/graphql?access_token=" + Storage.get('access_token'),
        query: users
        variables: variables
      .then (res) ->
        $scope.ui.users = res.data.data.user.data
    else
      $http.get "#{config.eadmin.baseUrl}/account/groups/#{$scope.ui.groupId}/users?access_token=" + Storage.get('access_token') + "&product_id=#{config.eadmin.clientId}",
        params:
          limit: 1000
      .then (res) ->
        $scope.ui.users = res.data.data

  fetchLogs = ->
    $scope.ui.isLoading = true
    $http.get "#{config.api.baseUrl}/manage/log_usages?access_token=" + Storage.get('access_token'),
      params:
        original_id: $scope.ui.wechat
        user_id: $scope.ui.user
        start_date: moment($scope.ui.date.startDate).format('YYYY-MM-DD 00:00')
        end_date: moment($scope.ui.date.endDate).format('YYYY-MM-DD 23:59')
        operation: $scope.ui.activeCountry
        limit: $scope.ui.perPage
        offset: ($scope.ui.currentPage - 1) * $scope.ui.perPage
    .then (res) ->
      $scope.ui.isLoading = false
      $scope.ui.logs = []
      _.each res.data.data, (val) ->
        val.created_at = moment(val.created_at).format('YYYY-MM-DD HH:mm')
        _.each val.process, (valProcess) ->
          valProcess.created_at = moment(val.created_at).format('YYYY-MM-DD HH:mm')
        $scope.ui.logs.push val
        $scope.ui.logs.splice $scope.ui.logs.length, 0, {show: false, value: val}
      $scope.ui.totalItems = res.data.count
    .catch (error) ->
      if error.data.error.indexOf('errtext') >= 0
        err = JSON.parse error.data.error
        growl.error err.errtext
      else
        growl.error('網絡連接失敗，請稍後重試')

  $scope.$watch 'ui.currentPage', fetchLogs

  $scope.search = ->
    fetchLogs()

  $scope.openData = (_index) ->
    $scope.ui.logs[_index].show = !$scope.ui.logs[_index].show

  $scope.$watch 'ui.wechat', (newValue, oldValue) ->
    $scope.ui.users = []
    $scope.ui.groupId = ''
    return if newValue == undefined or newValue == null

    _.each $scope.ui.wechats, (data) ->
      $scope.ui.groupId = data.user_group_id if newValue == data.original_id

    fetchUsers()
